module.exports = __webpack_public_path__ + "img/abstract3.3c34653.jpg";